// Customer Service Skills organized by subcategories
export const CUSTOMER_SERVICE_SKILLS_CATEGORIES = [
  {
    name: 'Communication Skills',
    skills: [
      'Active Listening', 'Clear Communication', 'Phone Etiquette',
      'Email Communication', 'Written Communication', 'Verbal Communication',
      'Non-verbal Communication', 'Empathetic Communication', 'Multilingual Support',
      'Professional Tone', 'Positive Language', 'Clear Explanation',
      'Customer Engagement', 'Follow-up Communication', 'Documentation Skills'
    ]
  },
  {
    name: 'Problem Resolution',
    skills: [
      'Problem Analysis', 'Solution Finding', 'Critical Thinking',
      'Decision Making', 'Conflict Resolution', 'Complaint Handling',
      'Issue Escalation', 'Root Cause Analysis', 'Problem Prevention',
      'Service Recovery', 'Crisis Management', 'Resolution Planning',
      'Follow-through', 'Quality Assurance', 'Process Improvement'
    ]
  },
  {
    name: 'Customer Relations',
    skills: [
      'Relationship Building', 'Customer Rapport', 'Trust Building',
      'Customer Retention', 'Customer Loyalty', 'Account Management',
      'Customer Feedback', 'Customer Advocacy', 'Customer Experience',
      'Service Personalization', 'Customer Education', 'Brand Representation',
      'Customer Understanding', 'Cultural Awareness', 'Service Excellence'
    ]
  },
  {
    name: 'Technical Support',
    skills: [
      'Technical Knowledge', 'Product Expertise', 'System Navigation',
      'Troubleshooting', 'Remote Support', 'Technical Documentation',
      'Software Support', 'Hardware Support', 'Network Support',
      'Technical Training', 'Update Knowledge', 'Technical Communication',
      'Error Resolution', 'System Maintenance', 'Technical Resources'
    ]
  },
  {
    name: 'Sales Support',
    skills: [
      'Product Knowledge', 'Sales Techniques', 'Cross-selling',
      'Upselling', 'Sales Communication', 'Needs Assessment',
      'Product Demonstration', 'Price Negotiation', 'Sales Follow-up',
      'Lead Generation', 'Sales Documentation', 'Sales Strategy',
      'Customer Acquisition', 'Sales Closing', 'Revenue Generation'
    ]
  },
  {
    name: 'Service Operations',
    skills: [
      'Service Standards', 'Quality Control', 'Process Management',
      'Time Management', 'Resource Allocation', 'Team Coordination',
      'Performance Metrics', 'Service Monitoring', 'Workflow Optimization',
      'Service Innovation', 'Operational Efficiency', 'Service Planning',
      'Resource Management', 'Service Analytics', 'Process Documentation'
    ]
  },
  {
    name: 'Digital Service',
    skills: [
      'Digital Communication', 'Online Support', 'Chat Support',
      'Social Media Service', 'Digital Tools', 'CRM Systems',
      'Service Platforms', 'Digital Documentation', 'Online Resources',
      'Digital Workflow', 'Virtual Support', 'Digital Integration',
      'Platform Management', 'Digital Analytics', 'Online Security'
    ]
  },
  {
    name: 'Service Leadership',
    skills: [
      'Team Leadership', 'Service Strategy', 'Performance Management',
      'Team Development', 'Quality Management', 'Service Innovation',
      'Change Management', 'Resource Planning', 'Team Motivation',
      'Service Vision', 'Strategic Planning', 'Team Coaching',
      'Service Culture', 'Leadership Skills', 'Decision Making'
    ]
  },
  {
    name: 'Emotional Intelligence',
    skills: [
      'Empathy', 'Patience', 'Self-control',
      'Stress Management', 'Emotional Awareness', 'Adaptability',
      'Resilience', 'Positive Attitude', 'Professional Demeanor',
      'Conflict Management', 'Emotional Regulation', 'Social Awareness',
      'Relationship Management', 'Self-awareness', 'Social Skills'
    ]
  },
  {
    name: 'Service Analytics',
    skills: [
      'Data Analysis', 'Performance Metrics', 'Customer Insights',
      'Service Reporting', 'Trend Analysis', 'Quality Metrics',
      'Customer Feedback Analysis', 'Service Analytics', 'KPI Monitoring',
      'Data Interpretation', 'Statistical Analysis', 'Report Generation',
      'Analytics Tools', 'Data Visualization', 'Predictive Analysis'
    ]
  },
  {
    name: 'Multichannel Support',
    skills: [
      'Channel Management', 'Omnichannel Support', 'Channel Integration',
      'Cross-channel Service', 'Channel Optimization', 'Service Consistency',
      'Channel Strategy', 'Platform Knowledge', 'Channel Analytics',
      'Service Adaptation', 'Channel Coordination', 'Platform Integration',
      'Channel Innovation', 'Service Flexibility', 'Channel Development'
    ]
  },
  {
    name: 'Quality Assurance',
    skills: [
      'Quality Standards', 'Service Monitoring', 'Performance Review',
      'Quality Control', 'Compliance Management', 'Standard Operating Procedures',
      'Quality Metrics', 'Service Audits', 'Process Improvement',
      'Quality Documentation', 'Best Practices', 'Quality Training',
      'Service Excellence', 'Quality Systems', 'Continuous Improvement'
    ]
  }
];

// Export flattened list for backward compatibility
export const CUSTOMER_SERVICE_SKILLS = CUSTOMER_SERVICE_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
